import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "modal-wrap default-modal" }
const _hoisted_2 = {
  class: "modal fade",
  id: "chatChannelMemberModal",
  tabindex: "-1",
  "aria-labelledby": "memberModalLabel",
  "aria-hidden": "true"
}
const _hoisted_3 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_4 = { class: "modal-content" }
const _hoisted_5 = { class: "modal-header" }
const _hoisted_6 = /*#__PURE__*/_createVNode("h5", {
  class: "modal-title",
  id: "memberModalLabel"
}, "Member", -1)
const _hoisted_7 = /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×", -1)
const _hoisted_8 = { class: "member-list pr-0" }
const _hoisted_9 = { class: "round-img" }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { key: 1 }
const _hoisted_14 = { key: 1 }
const _hoisted_15 = { key: 1 }
const _hoisted_16 = { key: 0 }
const _hoisted_17 = /*#__PURE__*/_createTextVNode(" ( ")
const _hoisted_18 = { key: 0 }
const _hoisted_19 = { key: 0 }
const _hoisted_20 = { key: 1 }
const _hoisted_21 = { key: 1 }
const _hoisted_22 = /*#__PURE__*/_createTextVNode(" ) ")
const _hoisted_23 = /*#__PURE__*/_createVNode("i", {
  class: "fas fa-info-circle",
  style: {"cursor":"pointer"},
  title: "More Info"
}, null, -1)
const _hoisted_24 = { key: 2 }
const _hoisted_25 = {
  key: 3,
  class: "member-tooltip bg-light border p-2 mt-1 rounded shadow-sm"
}
const _hoisted_26 = { key: 0 }
const _hoisted_27 = /*#__PURE__*/_createVNode("strong", null, "Valid Till:", -1)
const _hoisted_28 = /*#__PURE__*/_createTextVNode(" Never Expire ")
const _hoisted_29 = { key: 1 }
const _hoisted_30 = /*#__PURE__*/_createVNode("strong", null, "Valid Till:", -1)
const _hoisted_31 = /*#__PURE__*/_createVNode("strong", null, "Conversation History From:", -1)
const _hoisted_32 = { class: "modal-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, [
          _createVNode("div", _hoisted_5, [
            _hoisted_6,
            _createVNode("button", {
              type: "button",
              class: "close",
              "data-dismiss": "modal",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.hideChannelMemberModal && _ctx.hideChannelMemberModal(...args))),
              "aria-label": "Close"
            }, [
              _hoisted_7
            ])
          ]),
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.members, (member, memberIndex) => {
            return (_openBlock(), _createBlock("div", {
              class: "modal-body",
              key: memberIndex
            }, [
              _createVNode("div", _hoisted_8, [
                _createVNode("div", _hoisted_9, [
                  (member.user?.image)
                    ? (_openBlock(), _createBlock("img", {
                        key: 0,
                        src: member.user.image,
                        alt: ""
                      }, null, 8, ["src"]))
                    : (_openBlock(), _createBlock("img", {
                        key: 1,
                        src: _ctx.imageUrl ? `${_ctx.imageUrl}img/no-user.jpg` : 'img/no-user.jpg',
                        alt: ""
                      }, null, 8, ["src"]))
                ]),
                ((member.user?.email || member.user?.mobile_number) && !member.user?.first_name && !member.user?.last_name)
                  ? (_openBlock(), _createBlock("p", _hoisted_10, [
                      (member.user.email && member.user.mobile_number)
                        ? (_openBlock(), _createBlock("span", _hoisted_11, [
                            (member.user.email === member.user.mobile_number)
                              ? (_openBlock(), _createBlock("span", _hoisted_12, _toDisplayString(member.user.email), 1))
                              : (_openBlock(), _createBlock("span", _hoisted_13, _toDisplayString(member.user.email) + " / " + _toDisplayString(member.user.mobile_number), 1))
                          ]))
                        : (_openBlock(), _createBlock("span", _hoisted_14, _toDisplayString(member.user.email || member.user.mobile_number), 1))
                    ]))
                  : _createCommentVNode("", true),
                ((member.user?.first_name || member.user?.last_name) && (member.user?.email || member.user?.mobile_number))
                  ? (_openBlock(), _createBlock("p", _hoisted_15, [
                      _createTextVNode(_toDisplayString(member.user.first_name) + " " + _toDisplayString(member.user.last_name) + " ", 1),
                      (_ctx.userRole.code === 'owner' || _ctx.userRole.code === 'co-owner')
                        ? (_openBlock(), _createBlock("span", _hoisted_16, [
                            _hoisted_17,
                            (member.user.email && member.user.mobile_number)
                              ? (_openBlock(), _createBlock("span", _hoisted_18, [
                                  (member.user.email === member.user.mobile_number)
                                    ? (_openBlock(), _createBlock("span", _hoisted_19, _toDisplayString(member.user.email), 1))
                                    : (_openBlock(), _createBlock("span", _hoisted_20, _toDisplayString(member.user.email) + " / " + _toDisplayString(member.user.mobile_number), 1))
                                ]))
                              : (_openBlock(), _createBlock("span", _hoisted_21, _toDisplayString(member.user.email || member.user.mobile_number), 1)),
                            _hoisted_22
                          ]))
                        : _createCommentVNode("", true),
                      (member.invitation)
                        ? (_openBlock(), _createBlock("span", {
                            key: 1,
                            class: "info-icon",
                            onMouseenter: ($event: any) => (_ctx.activeTooltipIndex = memberIndex),
                            onMouseleave: _cache[2] || (_cache[2] = ($event: any) => (_ctx.activeTooltipIndex = null))
                          }, [
                            _hoisted_23
                          ], 40, ["onMouseenter"]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true),
                ((member.user?.first_name || member.user?.last_name) && !member.user?.email && !member.user?.mobile_number)
                  ? (_openBlock(), _createBlock("p", _hoisted_24, _toDisplayString(member.user.first_name) + " " + _toDisplayString(member.user.last_name), 1))
                  : _createCommentVNode("", true),
                (_ctx.activeTooltipIndex === memberIndex)
                  ? (_openBlock(), _createBlock("div", _hoisted_25, [
                      (member.invitation?.validity === 0)
                        ? (_openBlock(), _createBlock("p", _hoisted_26, [
                            _hoisted_27,
                            _hoisted_28
                          ]))
                        : (member.invitation?.completed_date && member.invitation?.validity)
                          ? (_openBlock(), _createBlock("p", _hoisted_29, [
                              _hoisted_30,
                              _createTextVNode(" " + _toDisplayString(_ctx.calculateValidTill(member.invitation.completed_date, member.invitation.validity)), 1)
                            ]))
                          : _createCommentVNode("", true),
                      _createVNode("p", null, [
                        _hoisted_31,
                        _createTextVNode(" " + _toDisplayString(_ctx.formatDate(member.invitation?.message_from_date) ?? 'N/A'), 1)
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]))
          }), 128)),
          _createVNode("div", _hoisted_32, [
            _createVNode("button", {
              type: "button",
              class: "btn secondary-btn",
              "data-dismiss": "modal",
              onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.hideChannelMemberModal && _ctx.hideChannelMemberModal(...args)))
            }, " Close ")
          ])
        ])
      ])
    ])
  ]))
}